'use client'

import { useEffect, useState, useMemo } from 'react'
import { useRouter, usePathname } from 'next/navigation'
import { createClient } from '@/lib/supabase/client'
import { User } from '@supabase/supabase-js'

export function useAuthRedirect(isProtectedRoute = true) {
  const router = useRouter()
  const pathname = usePathname()
  const [isLoading, setIsLoading] = useState(true)
  const supabase = useMemo(() => createClient(), [])
  const [user, setUser] = useState<User | null>(null)
  const authRoutes = ['/login', '/signup']

  useEffect(() => {
    // Set loading immediately when pathname changes
    setIsLoading(true)

    const checkAuth = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser()
        setUser(user)

        // Handle redirects based on auth state
        if (!user && isProtectedRoute) {
          router.replace('/login') // Use replace instead of push
        } else if (user && authRoutes.includes(pathname)) {
          router.replace('/') // Use replace instead of push
        }
      } catch (error) {
        console.error('Auth check failed:', error)
      } finally {
        setIsLoading(false)
      }
    }

    checkAuth()
  }, [pathname, router, isProtectedRoute, supabase.auth])

  return { user, isLoading }
}
